import { SearchResultsHitsHolder } from '#/modules/search/components/Results/Hits/SearchResultsHitsHolder';
import { range } from '#/utils/functional/array/range';

import { SearchLoadingSectionMockResultsItem } from './SearchLoadingSectionMockResultsItem';

type Props = {
  hideLabel?: boolean;
  items?: number;
};

export function SearchLoadingSectionMockResults({
  hideLabel,
  items = 10,
}: Props) {
  return (
    <SearchResultsHitsHolder>
      {range(items).map((_, index) => (
        <SearchLoadingSectionMockResultsItem
          // oxlint-disable-next-line react/no-array-index-key
          key={index}
          hideLabel={hideLabel}
        />
      ))}
    </SearchResultsHitsHolder>
  );
}
